import React from 'react';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import { StyledModal } from 'components/shared';
import loadingLogo from 'assets/home4.gif';

const LogoContainer = styled.div`
  max-width: 100px;

  @media ${breakpoints.md} {
    max-width: 300px;
  }
`;

const WaitingScreen = (props) => {
  const { isOpen = false } = props;

  return (
    <StyledModal
      isOpen={isOpen}
      className='select-none flex w-full'
      data-aos='fade'
    >
      <div className='flex justify-center items-center w-screen h-screen'>
        <LogoContainer>
          <img className='rounded' src={loadingLogo} alt='loading logo' />
        </LogoContainer>
      </div>
    </StyledModal>
  );
};
export default WaitingScreen;
